import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Typography } from '@comparethemarketau/manor-typography';
import { getBreakpointFromManor } from 'ctm-components';

const useStyles = createUseStyles((theme) => ({
    title: {
        fontWeight: theme.fontWeight.bold,
        lineHeight: theme.lineHeight.tight,
        marginBottom: theme.spacing['12']
    },
    label: ({ breakpoint }) => {
        if (breakpoint === 'xs' || breakpoint === 'sm') {
            return {
                fontSize: theme.fontSize['4xl']
            };
        }
        if (breakpoint === 'md') {
            return {
                fontSize: theme.fontSize['5xl']
            };
        }
        return {
            fontSize: theme.fontSize['6xl']
        };
    }
}));

const SectionTitle = ({ label }) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });

    return (
        <Typography className={classNames(classes.title, classes.label)}>
            {label}
        </Typography>
    );
};

SectionTitle.propTypes = {
    label: PropTypes.string.isRequired
};

export { SectionTitle };
